/** Límite de errores de React: captura excepciones de render y muestra una página "Algo salió mal" con reintentar, ir al inicio y detalle del error. */
import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button, Typography } from "antd";
import "../../views/404/notfound.css";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = (): void => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleGoHome = (): void => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="error-page">
          <div className="error-page-card">
            <p className="error-page-code">!</p>
            <Typography.Title level={4} className="error-page-title" style={{ margin: "0 0 8px" }}>
              Algo salió mal
            </Typography.Title>
            <p className="error-page-description">
              Se produjo un error inesperado. Si el problema persiste, contactá al administrador.
            </p>
            <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
              <Button className="error-page-btn" onClick={this.handleReload}>
                Reintentar
              </Button>
              <Button type="primary" className="error-page-btn" onClick={this.handleGoHome}>
                Ir al inicio
              </Button>
            </div>
            {this.state.error && (
              <details style={{ marginTop: 24, textAlign: "left" }}>
                <summary
                  style={{
                    fontSize: 12,
                    color: "#8c8c8c",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  Detalles del error
                </summary>
                <pre
                  style={{
                    marginTop: 8,
                    padding: 12,
                    background: "#f5f5f5",
                    borderRadius: 3,
                    fontSize: 11,
                    overflow: "auto",
                    maxHeight: 120,
                    color: "#595959",
                  }}
                >
                  {this.state.error.message}
                  {"\n"}
                  {this.state.error.stack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
